import { call, put, takeLatest } from "redux-saga/effects";
// Login Redux States
import { GET_ENTITY, EDIT_ENTITY, ADD_ENTITY } from "./actionTypes";
import {
  addEntity,
  editEntity,
  getEntity,
} from "../../http/fundLync/entityAndAddress.helper";
import { allEntity } from "../actions";
import { decryptedValue } from "common/utility";

function* addEntities({ payload: { entity, history } }) {
  try {
    const responseFromAPI = yield call(addEntity, entity);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/listEntity`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* getEntities({ payload: { entity } }) {
  try {
    const responseFromAPI = yield call(getEntity, entity);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allEntity({ data }));
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* editEntities({ payload: { entity, history } }) {
  try {
    const responseFromAPI = yield call(editEntity, entity);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/listEntity`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* entitySaga() {
  yield takeLatest(GET_ENTITY, getEntities);
  yield takeLatest(EDIT_ENTITY, editEntities);
  yield takeLatest(ADD_ENTITY, addEntities);
}

export default entitySaga;
